export const WHISPERING_FOREST_PORTAL = Object.freeze({
  x: 1480,
  y: 1640,
  width: 96,
  height: 96,
});

export const WHISPERING_FOREST_PORTAL_RETURN_SPAWN = Object.freeze({
  x: WHISPERING_FOREST_PORTAL.x + WHISPERING_FOREST_PORTAL.width / 2,
  y: WHISPERING_FOREST_PORTAL.y + WHISPERING_FOREST_PORTAL.height / 2 + 20,
});
